import { CommonInputProps } from './common';
import { SizeInput } from './SizeInput';
import { ColorInput } from './ColorInput';
import { Vertical, Horizontal } from 'packages/radiant-react/layout';
import ResetButtonWrapper from '../ResetButtonWrapper';
import styles from './styles.module.scss';

const parseBoxShadowValue = (value: string | undefined) => {
  const values = (value || '')
    .trim()
    .split(/\s+/)
    .filter((val) => val !== '');
  if (values.length !== 5) {
    return {
      blur: '0px',
      spread: '0px',
      color: 'initial',
      xOffset: '0px',
      yOffset: '0px',
    };
  }

  const [xOffset, yOffset, blur, spread, color] = values;
  return {
    blur,
    spread,
    color,
    xOffset,
    yOffset,
  };
};

const shadowPositions = {
  blur: 2,
  color: 4,
  xOffset: 0,
  yOffset: 1,
  spread: 3,
};

export const BoxShadowInput = ({ onChange, value, info }: CommonInputProps) => {
  const { blur, color, xOffset, yOffset, spread } = parseBoxShadowValue(value);

  const handleChange = (value: string | undefined, type: keyof typeof shadowPositions) => {
    const values = [xOffset, yOffset, blur, spread, color];
    values[shadowPositions[type]] = value || (type === 'color' ? 'initial' : '0px');
    onChange(values.join(' '));
  };

  const handleReset = (type: keyof typeof shadowPositions) => {
    const values = [xOffset, yOffset, blur, spread, color];
    // Reset to default values
    values[shadowPositions[type]] = type === 'color' ? 'initial' : '0px';
    onChange(values.join(' '));
  };

  return (
    <Vertical className={styles.boxShadowWrapper}>
      <ResetButtonWrapper
        updateVariableValue={() => handleReset('xOffset')}
        variableName="Offset X"
      >
        <SizeInput
          name="Offset X"
          value={xOffset == '0px' ? '' : xOffset}
          onChange={(value) => handleChange(value, 'xOffset')}
          info={info}
        />
      </ResetButtonWrapper>

      <ResetButtonWrapper
        updateVariableValue={() => handleReset('yOffset')}
        variableName="Offset Y"
      >
        <SizeInput
          name="Offset Y"
          value={yOffset == '0px' ? '' : yOffset}
          onChange={(value) => handleChange(value, 'yOffset')}
          info={info}
        />
      </ResetButtonWrapper>

      <ResetButtonWrapper
        updateVariableValue={() => handleReset('blur')}
        variableName="Blur Shadow"
      >
        <SizeInput
          name="Blur Shadow"
          value={blur == '0px' ? '' : blur}
          onChange={(value) => handleChange(value, 'blur')}
          info={info}
        />
      </ResetButtonWrapper>

      <ResetButtonWrapper
        updateVariableValue={() => handleReset('spread')}
        variableName="Spread Shadow"
      >
        <SizeInput
          name="Spread Shadow"
          value={spread == '0px' ? '' : spread}
          onChange={(value) => handleChange(value, 'spread')}
          info={info}
        />
      </ResetButtonWrapper>

      <ResetButtonWrapper
        updateVariableValue={() => handleReset('color')}
        variableName="Shadow Color"
      >
        <ColorInput
          name="Shadow Color"
          value={color}
          onChange={(value) => handleChange(value, 'color')}
          info={info}
        />
      </ResetButtonWrapper>
    </Vertical>
  );
};
